require('../bootConfig');
import '@babel/polyfill';
import Vuex from 'vuex';
import Vue from 'vue';

import App from './App.vue';
import assessmentStore from './store';
import Home from './components/Home.vue';
import ReportWindow from './components/ReportWindow.vue';

import TinymceNew from '../shared_components/TinymceNew.vue';
import Welcome from './components/Welcome.vue';
import Feedback from './components/Feedback.vue';
import BaseInput from '@shared/BaseInput.vue';
import BaseSelect from '@shared/BaseSelect.vue';
import BaseRadioGroup from '@shared/BaseRadioGroup.vue';

import {
  AnnualReport,
  ProductionInformation,
  StatisticsReport,
  StockBondSummary,
  SalaryReport,
  Images,
  SimulationReport,
  PlatformReport,
} from './components/reports';

import * as Sentry from '@sentry/vue';
import { Integrations } from '@sentry/tracing';
import * as os from 'os';

if (!os.hostname().includes('local')) {
  Sentry.init({
    Vue,
    dsn: process.env.SENTRY_DSN_UI,
    integrations: [new Integrations.BrowserTracing()],
    environment: process.env.SERVER,
    // Track child components and see more details about the rendering process
    tracingOptions: {
      trackComponents: true,
    },

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 0.5,
    // Call original Vue’s logError function as well
    logErrors: process.env.SERVER === 'awsprod' ? false : true,
    // stack traces are automatically attached to all messages logged
    attachStacktrace: true,
    // Sentry will send all Vue components’ props for logging purpose
    attachProps: true,
  });
}

window.EventBus = new Vue();
window.Highcharts = require('highcharts');
require('highcharts/highcharts-more')(window.Highcharts);
require('highcharts/modules/solid-gauge')(window.Highcharts);
require('highcharts/modules/heatmap')(window.Highcharts);

$(function () {
  $('[data-toggle="tooltip"]').tooltip();
});
require('bootstrap-sass');

Vue.use(VueRouter);
Vue.use(Vuex);

const store = new Vuex.Store(assessmentStore);

Vue.component('wysiwyg', TinymceNew);
Vue.component('BaseInput', BaseInput);
Vue.component('BaseSelect', BaseSelect);
Vue.component('BaseRadioGroup', BaseRadioGroup);

const routes = [
  { path: '/capsiminbox/webapp', meta: { showTopNav: true }, component: Home },
  {
    path: '/capsiminbox/webapp/reports',
    name: 'report-window',
    component: ReportWindow,
    children: [
      {
        path: 'annual-report',
        name: 'annual-report',
        component: AnnualReport,
        meta: { title: 'Annual Report' },
      },
      {
        path: 'production-information-report',
        name: 'production-information-report',
        component: ProductionInformation,
        meta: { title: 'Production Information' },
      },
      {
        path: 'salary-report',
        name: 'salary-report',
        component: SalaryReport,
        meta: { title: 'Salary Report' },
      },
      {
        path: 'statistics-report',
        name: 'statistics-report',
        component: StatisticsReport,
        meta: { title: 'Statistics Report' },
      },
      {
        path: 'stock-bond-report',
        name: 'stock-bond-report',
        component: StockBondSummary,
        meta: { title: 'Stock & Bond Summary' },
      },
      {
        path: 'simulation-report',
        name: 'simulation-report',
        component: SimulationReport,
        meta: { title: 'Simulation Report' },
      },
      {
        path: 'platform-report/:reportType/:team?',
        name: 'platform-report',
        component: PlatformReport,
        meta: {
          title: (route) =>
            `${
              route.params.reportType.charAt(0).toUpperCase() + route.params.reportType.slice(1)
            } Report`,
        },
      },
      { path: 'images/:id', name: 'images', component: Images, meta: { title: 'images' } },
      { path: '', redirect: 'annual-report' },
    ],
  },
  {
    path: '/capsiminbox/demo/assessment',
    meta: { showTopNav: true },
    name: 'assessment',
    component: Home,
  },
  { path: '/capsiminbox/demo/feedback', name: 'feedback', component: Feedback },
  { path: '/capsiminbox/demo/welcome', name: 'demo-welcome', component: Welcome },

  { path: '/capsiminbox/rehearsal', meta: { showTopNav: true }, component: Home },
  {
    path: '/capsiminbox/rehearsal/annual-report',
    name: 'annual-report',
    component: AnnualReport,
    meta: { title: 'Annual Report' },
  },
  {
    path: '/capsiminbox/rehearsal/production-information-report',
    name: 'production-information-report',
    component: ProductionInformation,
    meta: { title: 'Production Information' },
  },
  {
    path: '/capsiminbox/rehearsal/statistics-report',
    name: 'statistics-report',
    component: StatisticsReport,
    meta: { title: 'Statistics Report' },
  },
  {
    path: '/capsiminbox/rehearsal/stock-bond-report',
    name: 'stock-bond-report',
    component: StockBondSummary,
    meta: { title: 'Stock & Bond Summary' },
  },
  {
    path: '/capsiminbox/authoring-platform/preview',
    meta: { showTopNav: true },
    name: 'assessment',
    component: Home,
  },

  { path: '/capsiminbox/demo/*', redirect: '/capsiminbox/demo/welcome' },
];

const router = new VueRouter({
  routes,
  mode: 'history',
  base: '/',
});

new Vue({
  // eslint-disable-line no-new
  router,
  el: '#app',
  store,
  render: (h) => h(App),
});
